import { render, staticRenderFns } from "./PaginationTool.vue?vue&type=template&id=06a0104c&scoped=true"
import script from "./PaginationTool.vue?vue&type=script&lang=js"
export * from "./PaginationTool.vue?vue&type=script&lang=js"
import style0 from "./PaginationTool.vue?vue&type=style&index=0&id=06a0104c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0104c",
  null
  
)

export default component.exports